import { RendererContextType } from '../../../../contexts/RendererContext';

type Project = {
  mapVisible?: boolean | null;
  pointClouds: { id: string }[];
};

export function syncMap(viewer: RendererContextType['viewer'], project: Project | undefined, initializedPointclouds: string[]): void {
  if (!viewer || !project) return;
  if (!project.pointClouds.every((pointcloud) => initializedPointclouds.includes(pointcloud.id))) return;
  if (project.mapVisible) {
    viewer.showMap();
  } else {
    viewer.hideMap();
  }
}
